import { render, staticRenderFns } from "./ColumnItemContent.vue?vue&type=template&id=16e9c4d1&scoped=true"
import script from "./ColumnItemContent.vue?vue&type=script&lang=js"
export * from "./ColumnItemContent.vue?vue&type=script&lang=js"
import style0 from "./ColumnItemContent.vue?vue&type=style&index=0&id=16e9c4d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e9c4d1",
  null
  
)

export default component.exports